export const preflightQuestions = {
  initial: [
    {
      id: 'illness',
      text: "Are you feeling sick?",
      prefix: "Illness:",
      options: [
        { text: "Yes, I am feeling sick or have symptoms", value: "yes", isNegative: true },
        { text: "No, I do not feel sick", value: "no", isNegative: false }
      ],
      followUp: {
        condition: "yes",
        questions: [
          {
            id: 'illness_symptoms',
            text: "What symptoms are you experiencing?",
            prefix: "Symptoms:",
            type: 'multiSelect',
            options: [
              { text: "Fever", value: "fever", isNegative: true },
              { text: "Fatigue", value: "fatigue", isNegative: true },
              { text: "Headache", value: "headache", isNegative: true },
              { text: "Nausea", value: "nausea", isNegative: true },
              { text: "Other", value: "other", isNegative: true }
            ]
          },
          {
            id: 'illness_duration',
            text: "How long have you been experiencing these symptoms?",
            prefix: "Duration:",
            type: 'select',
            options: [
              { text: "Less than 24 hours", value: "24h" },
              { text: "1-3 days", value: "1-3d" },
              { text: "More than 3 days", value: "3d+" }
            ]
          }
        ]
      }
    },
    {
      id: 'medication',
      text: "Are you under any medication that could affect your performance?",
      prefix: "Medication:",
      options: [
        { text: "Yes, I am on medication", value: "yes", isNegative: true },
        { text: "No medication", value: "no", isNegative: false }
      ],
      followUp: {
        condition: "yes",
        questions: [
          {
            id: 'medication_type',
            text: "What type of medication are you taking?",
            prefix: "Medication Type:",
            type: 'multiSelect',
            options: [
              { text: "Prescription medication", value: "prescription" },
              { text: "Over-the-counter medication", value: "otc" },
              { text: "Prefer not to specify", value: "unspecified" }
            ]
          },
          {
            id: 'medication_effects',
            text: "Does the medication cause any side effects that might affect your flying?",
            prefix: "Side Effects:",
            type: 'select',
            options: [
              { text: "Yes, drowsiness", value: "drowsiness", isNegative: true },
              { text: "Yes, dizziness", value: "dizziness", isNegative: true },
              { text: "No side effects", value: "none", isNegative: false },
              { text: "Unsure", value: "unsure", isNegative: true }
            ]
          }
        ]
      }
    },
    {
      id: 'stress',
      text: "Are you feeling any stress?",
      prefix: "Stress:",
      options: [
        { text: "Yes, I am feeling stressed", value: "yes", isNegative: true },
        { text: "No, I am not stressed", value: "no", isNegative: false }
      ],
      followUp: {
        condition: "yes",
        questions: [
          {
            id: 'stress_level',
            text: "How would you rate your stress level?",
            prefix: "Stress Level:",
            type: 'select',
            options: [
              { text: "Mild - Noticeable but manageable", value: "mild", isNegative: false },
              { text: "Moderate - Affecting concentration", value: "moderate", isNegative: true },
              { text: "Severe - Significantly distracting", value: "severe", isNegative: true }
            ]
          },
          {
            id: 'stress_source',
            text: "What is the primary source of your stress?",
            prefix: "Source:",
            type: 'select',
            options: [
              { text: "Work-related", value: "work" },
              { text: "Personal matters", value: "personal" },
              { text: "Flight-related concerns", value: "flight" },
              { text: "Other", value: "other" }
            ]
          }
        ]
      }
    },
    {
      id: 'alcohol',
      text: "When did you last consume alcohol?",
      prefix: "Alcohol:",
      options: [
        { text: "Less than 8 hours ago", value: "under_8", isNegative: true },
        { text: "Between 8-24 hours ago", value: "8_to_24", isNegative: false },
        { text: "More than 24 hours ago", value: "over_24", isNegative: false },
        { text: "I don't drink alcohol", value: "none", isNegative: false }
      ],
      followUp: {
        condition: "under_8",
        questions: [
          {
            id: 'alcohol_amount',
            text: "How many drinks did you consume?",
            prefix: "Amount:",
            type: 'select',
            options: [
              { text: "1-2 drinks", value: "1-2" },
              { text: "3-4 drinks", value: "3-4" },
              { text: "More than 4 drinks", value: "4+" }
            ]
          }
        ]
      }
    },
    {
      id: 'sleep',
      text: "How many hours have you slept in the last 24 hours?",
      prefix: "Sleep:",
      options: [
        { text: "Less than 6 hours", value: "under_6", isNegative: true },
        { text: "6-8 hours", value: "6_to_8", isNegative: false },
        { text: "More than 8 hours", value: "over_8", isNegative: false }
      ],
      followUp: {
        condition: "under_6",
        questions: [
          {
            id: 'sleep_quality',
            text: "How would you rate the quality of your sleep?",
            prefix: "Sleep Quality:",
            type: 'select',
            options: [
              { text: "Poor - Frequently interrupted", value: "poor", isNegative: true },
              { text: "Fair - Some interruptions", value: "fair", isNegative: false },
              { text: "Good - Despite short duration", value: "good", isNegative: false }
            ]
          },
          {
            id: 'sleep_reason',
            text: "What was the main reason for reduced sleep?",
            prefix: "Reason:",
            type: 'select',
            options: [
              { text: "Work schedule", value: "work" },
              { text: "Personal choice", value: "personal" },
              { text: "Difficulty sleeping", value: "insomnia" },
              { text: "Other commitments", value: "other" }
            ]
          }
        ]
      }
    },
    {
      id: 'emotional_state',
      text: "Are you feeling any of angry, depressed, or have anxiety about something?",
      prefix: "Emotional State:",
      options: [
        { text: "Yes, I am experiencing these emotions", value: "yes", isNegative: true },
        { text: "No, I am emotionally stable", value: "no", isNegative: false }
      ],
      followUp: {
        condition: "yes",
        questions: [
          {
            id: 'emotional_type',
            text: "Which emotions are you experiencing?",
            prefix: "Emotions:",
            type: 'multiSelect',
            options: [
              { text: "Anger", value: "anger", isNegative: true },
              { text: "Depression", value: "depression", isNegative: true },
              { text: "Anxiety", value: "anxiety", isNegative: true }
            ]
          },
          {
            id: 'emotional_intensity',
            text: "How intense are these emotions?",
            prefix: "Intensity:",
            type: 'select',
            options: [
              { text: "Mild - Noticeable but manageable", value: "mild", isNegative: false },
              { text: "Moderate - Affecting focus", value: "moderate", isNegative: true },
              { text: "Severe - Significantly impacting", value: "severe", isNegative: true }
            ]
          },
          {
            id: 'emotional_impact',
            text: "Do you feel these emotions might affect your ability to fly safely?",
            prefix: "Impact:",
            type: 'select',
            options: [
              { text: "Yes, significantly", value: "significant", isNegative: true },
              { text: "Somewhat, but manageable", value: "moderate", isNegative: true },
              { text: "No impact on flying ability", value: "none", isNegative: false }
            ]
          }
        ]
      }
    }
  ]
}; 